'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var TableWithHeader = require('../components/TableWithHeader/TableWithHeader.js');
var RenderRows = require('../components/RenderRows/RenderRows.js');
var PaginationTableFooter = require('../components/PaginationTableFooter/PaginationTableFooter.js');

var SplitPaginationTableGenerator = function (props) {
    var headCells = props.headCells, rows = props.rows, generateRow = props.generateRow, _a = props.dense, dense = _a === void 0 ? false : _a, _b = props.rowsPerPage, rowsPerPage = _b === void 0 ? 1 : _b, _c = props.page, page = _c === void 0 ? 0 : _c, totalRows = props.totalRows, fetchRows = props.fetchRows, _d = props.hoverable, hoverable = _d === void 0 ? false : _d, NoResultsComponent = props.NoResultsComponent;
    return {
        Table: function () { return (React__default.createElement(TableWithHeader, { headCells: headCells, dense: dense },
            React__default.createElement(RenderRows, { rows: rows, generateRow: generateRow, hoverable: hoverable }))); },
        Pagination: function () { return (React__default.createElement(PaginationTableFooter, { page: page, tableColumns: headCells.length, totalRows: totalRows, rowsPerPage: rowsPerPage, handleChangePage: fetchRows, NoResultsComponent: NoResultsComponent })); },
    };
};

module.exports = SplitPaginationTableGenerator;
